export default {
  POST_CREATED_LIST_REQUEST: 'APP/POST_CREATED/POST_CREATED_LIST_REQUEST',
  POST_CREATED_LIST_SUCCESS: 'APP/POST_CREATED/POST_CREATED_LIST_SUCCESS',
  POST_CREATED_LIST_ERROR: 'APP/POST_CREATED/POST_CREATED_LIST_ERROR',
};
